import { useEffect, useState } from "react";
import "./CreditorSummary.scss";
import { useGetCreditorSummaryDataQuery } from "./CreditorSummaryReducer";
import { useNavigate, useParams } from "react-router-dom";
import { CommentHistory } from "@/features/claimsummary/summary/component/commentHistory";
import CustomAttributeValue from "@/components/CustomAttribute/CustomAttributeValue";
import { ENTITYTYPE } from "@/appConstants";
import { useCase } from "@/features/case/use-case";
import { CreditorFileuploader } from "@/features/creditor/summary/components/CreditorFileuploader";
import {
  MotifAccordion,
  MotifAccordionContent,
  MotifAccordionTrigger,
  MotifButton,
  MotifChip,
  MotifAccordionGroup,
  MotifIconButton,
  MotifCheckbox,
} from "@ey-xd/motif-react";
import {
  useGetPayeeTypeApiDataQuery,
} from "@/features/distributions/steps/calculationStepReducer";
import MaskedInput from "../MaskedInput";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getGovernmentType, havingEditPermission } from "@/utility/common";
import { EDIT_BUTTON_VARIANT, getCommonCopyImg } from "@/components/Images/CommonImages";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import CommonTooltipWrapper from "@/components/Tooltip/CommonTooltipWrapper";
import { AttributeType } from "../../Configuration/Attributes/type";
import MaskedLabel from "@/components/Form/Label/MaskedLabel";
function CreditorSummary() {
  const {t}=useTranslation()
  const [showAttributesWithValue,setShowAttributesWithValue]=useState<any>(true)
  const { caseId, creditorId } = useParams<{
    caseId: string;
    creditorId: string;
  }>();
  const caseData = useCase(caseId);
  const propData = {
    caseId: caseData.caseId,
    creditorId: creditorId || "",
  };
  const navigate = useNavigate();
  const { data, error, isLoading, refetch,isFetching } =
    useGetCreditorSummaryDataQuery(propData);
    const { data: payeeTypeData, isFetching: isPayeeTypeDataLoading } =
      useGetPayeeTypeApiDataQuery({
        CaseId: caseData.caseId,
      });

      const permissions = useSelector((state: any) => state.permissions);
      const {Creditor} = permissions; 


  const [contactsAccordianOpen, setContactsAccordianOpen] = useState(false);
  const [attributeAccordianOpen, setAttributeAccordianOpen] = useState(true);
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [notificationVisible, setNotificationVisible] = useState(false); 
  const [showField, setShowField] = useState<any>({})
  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading || isFetching || isPayeeTypeDataLoading) return <div>{t("global.globalNotifications.loadingMessage")}</div>;
  if (error) return <div>{t("global.globalNotifications.unExpectedError")}</div>;
  const handleViewIcon = (name: string) => {
    setShowField((prev: any) => ({ ...prev, [name]: !prev[name] }));
  };

  const renderPayeeName = (id: string) => {
    if (payeeTypeData !== undefined) {
      const payee = payeeTypeData?.results?.find((payee:any) => payee.id === id);
      return payee?.name;
    }
  }

  const copiedToClipBoard = (event: React.MouseEvent<HTMLButtonElement>, contactDetails: any) => {
    event.stopPropagation();
    setNotificationVisible(false);
    setNotification({
      ...notification,
      show: false,
      message: "",
      type: "success",
    });
    const namePart = [contactDetails.firstName, contactDetails.lastName].filter(Boolean).join(' ').trim();
    const addressPart = [contactDetails.address1, contactDetails.address2].filter(Boolean).join(' ').trim();
    const cityStatePostalPart = [contactDetails.city, contactDetails.provinceState, contactDetails.postalCode].filter(Boolean).join(', ').trim();
    const countryPart = contactDetails.country ? contactDetails.country.trim() : null;
    const addressParts = [
      namePart,
      addressPart,
      cityStatePostalPart,
      countryPart,
    ];
    const formattedAddress = addressParts
      .filter(part => part && part.trim() !== '')
      .join('\n');
    navigator.clipboard.writeText(formattedAddress)
    .then(() => {
      setNotificationVisible(true);
      setNotification({
        ...notification,
        show: true,
        message: t("global.globalNotifications.copiedToClipboard"),
        type: "success",
      });
    })
    .catch(err => {
      setNotificationVisible(true);
      setNotification({
        ...notification,
        show: true,
        message: t("global.globalNotifications.copiedToClipboardError"),
        type: "error",
      });
    });
  };
  const returnValue = (attributeType:any,value:any,picklistDefinitions:any) => {

    switch (attributeType) {
      case AttributeType.FreeText:
        return  value.textValue ? (
          value.textValue
        ) : (
          undefined
        );
      case AttributeType.Number:
      return value.numberValue || value.numberValue === 0 ? true : undefined;
      case AttributeType.Boolean:
        if (value.booleanValue === null) {
          return undefined;
        } else {
          if (value.booleanValue) {
            return t("pages.configuration.attributes.createAttribute.yes");
          } else {
            return t("pages.configuration.attributes.createAttribute.no");
          }
        }
      case AttributeType.Date:
        return value.dateValue
          ? value.dateValue
          : undefined;
      case AttributeType.SingleSelect:
        const selected = picklistDefinitions.filter((x: any) => {
          return x.id === value.selectedValue;
        });
        return selected.length !== 0 ? selected[0].name : undefined;
      case AttributeType.MutliSelect:
        const multiSelected = picklistDefinitions.filter((x: any) => {
          return value.selectedValues.includes(x.id);
        });

        return multiSelected.length !== 0
          ? multiSelected.map((x: any) => x.name).join()
          : undefined;
      case AttributeType.Currency:
        return value.amount || value.amount === 0 ? value.amount : undefined;
      case AttributeType.Document:
        return value.displayName ? value.displayName : undefined;
      default:
        return undefined;
    }
  };

  function filterAttributes(attribute:any){
    if(showAttributesWithValue){
      return attribute.value.attributeType!==AttributeType.Document && returnValue(attribute.value.attributeType,attribute.value,attribute.picklistDefinitions)?
      <div className="motif-col-lg-4 attribute-field">
    <div className="title">{attribute.name}</div>
    <div className="motif-body2-default-bold overFlowWrapBreakWord">
      <CustomAttributeValue
        attributeType={attribute.value.attributeType}
        value={attribute.value}
        picklistDefinitions={attribute.picklistDefinitions}
        metadataJSON={attribute.metadataJSON}
      />
    </div>
  </div>:<></>


    }
    else{
      return attribute.value.attributeType!==AttributeType.Document?
      <div className="motif-col-lg-4 attribute-field">
    <div className="title">{attribute.name}</div>
    <div className="motif-body2-default-bold overFlowWrapBreakWord">
      <CustomAttributeValue
        attributeType={attribute.value.attributeType}
        value={attribute.value}
        picklistDefinitions={attribute.picklistDefinitions}
        metadataJSON={attribute.metadataJSON}
      />
    </div>
  </div>:<></>


    }

  }
  function noAttributeWithValues():any{
    let div:any=document.getElementById("creditorCustomValuesView")
    let lenthOfNodes=div?.childNodes.length
    if(lenthOfNodes===0 && showAttributesWithValue){
      div.innerHTML=`<div  id="creditorCustomValuesViewDummyId" class="motif-row">
      <div class="mar-l-30">${t("global.globalNotifications.noAttributesFound")}</div>
      </div>`
     }
     else{
      let dummyDiv:any=document.getElementById("creditorCustomValuesViewDummyId")
      if(dummyDiv && !showAttributesWithValue){
        dummyDiv.remove()
      }
     }
  }
  return (
    <>
    {notificationVisible && (
            <NotificationGrid
              show={notification.show}
              message={notification.message}
              type={notification.type}
            />
      )}
      <div className="motif-container case-summary-form pad-v-20">
        <div className="motif-row justify-content-between align-items-center">
          <div className="motif-col-4">
            <div className="motif-body1-default-regular page-title">
              {t("pages.creditors.creditorView.creditorViewTitle")}
            </div>
            <div className="motif-body2-default-regular page-description">
              {t("pages.creditors.creditorView.creditorViewDescription")}
            </div>
          </div>
          <div className="motif-col-4">
            {havingEditPermission(Creditor) && (
              <MotifButton
                onClick={() => {
                  navigate(`/case/${caseId}/creditor/${creditorId}/edit`);
                }}
                size="small"
                type="submit"
                variant={EDIT_BUTTON_VARIANT}
              >
                {t("global.globalActions.edit")}
              </MotifButton>
            )}
          </div>
        </div>
      </div>
      <div className="motif-container main-container creditor-summary-view">
        <div className="motif-container section-container pad-t-20 pad-b-20 pad-l-40">
          <div className="motif-row">
            <div className="motif-col-lg-4">
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.creditorId")}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.creditorReference === null
                  ? "-"
                  : data.creditorIdentifier.creditorReference}
              </div>
            </div>
            <div className="motif-col-lg-4">
              <div className="title">
                {t(
                  "pages.creditors.creditorForm.formLabelDetails.creditorType"
                )}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.isOrganization
                  ? "Organization"
                  : "Individual"}
              </div>
            </div>
            <div
              className={`motif-col-lg-4 ${
                data.creditorIdentifier.isOrganization ? "hide" : ""
              }`}
            >
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.prefix")}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.prefix || "-"}
              </div>
            </div>
          </div>
          <div className="motif-row pad-t-30">
            <div
              className={`motif-col-lg-4 ${
                data.creditorIdentifier.isOrganization ? "hide" : ""
              }`}
            >
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.firstName")}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.firstName}
              </div>
            </div>
            <div
              className={`motif-col-lg-4 ${
                data.creditorIdentifier.isOrganization ? "hide" : ""
              }`}
            >
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.lastName")}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.lastName}{" "}
              </div>
            </div>
            <div
              className={`motif-col-lg-4 ${
                data.creditorIdentifier.isOrganization ? "" : "hide"
              }`}
            >
              <div className="title">
                {t(
                  "pages.creditors.creditorForm.formLabelDetails.businessName"
                )}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.businessName}
              </div>
            </div>
            <div className="motif-col-lg-4">
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.displayName")}
              </div>
              <div className="motif-body2-default-bold">
                {data?.creditorIdentifier?.displayName}{" "}
              </div>
            </div>
          </div>
          <div className="motif-row pad-t-30">
            <div className="motif-col-lg-4">
              <div className="title">
                {t("pages.creditors.creditorForm.formLabelDetails.description")}
              </div>
              <div className="motif-body2-default-bold overFlowWrapBreakWord">
                {data?.creditorIdentifier?.description}
              </div>
            </div>
            <div className="motif-col-lg-4">
              <div className="title">
                {t(
                  "pages.creditors.creditorForm.formLabelDetails.relationshipToDebtor"
                )}
              </div>
              <div className="motif-body2-default-bold">
                {" "}
                {data?.creditorIdentifier?.relationshipToDebtor}
              </div>
            </div>
          </div>
        </div>
        {data.customAttributes.length !== 0 ? (
          <MotifAccordion
            className="mar-t-40"
            onClose={() => setAttributeAccordianOpen(false)}
            onOpen={() => setAttributeAccordianOpen(true)}
            alignIconRight={true}
            useChevronIcon={true}
            open={attributeAccordianOpen}
          >
            <MotifAccordionTrigger>
              {t("pages.creditors.creditorView.creditorAttributesTitle")}
            </MotifAccordionTrigger>
            <MotifAccordionContent className="ccwp_claim_summary_accordian_wrapper">
              <div className="motif-container pad-t-10 pad-b-20 pad-l-40 ccwp_claim_summary_white_accordian">
                <div className="motif-row ">
              <MotifCheckbox className="motif-col-lg-4 attribute-field"  checked={showAttributesWithValue} onChange={(e:any)=>setShowAttributesWithValue(e.target.checked)}>{t("global.globalActions.showAttributesWithValues")}</MotifCheckbox>
              </div>
                <div id="creditorCustomValuesView" className="motif-row">
                  {data?.customAttributes.map((attribute: any) => {
                    return (
                      filterAttributes(attribute)
                    );
                  })}
                </div>

              </div>
            </MotifAccordionContent>
          </MotifAccordion>
        ) : (
          <></>
        )}
        {noAttributeWithValues()}
        <div className="motif-container case-summary-form pad-v-20 mar-t-40 ">
        <div className="motif-row justify-content-between align-items-center">
          <div className="motif-col-4 contacts-header">
            <div className="motif-body1-default-regular page-title">
              {t("pages.creditors.creditorForm.contactDetailsTitle")}
            </div>
            <div className="motif-body2-default-regular page-description">
              {t("pages.creditors.creditorView.creditorViewDescription")}
            </div>
          </div>
        </div>
      </div>
      <div className="motif-container main-container creditor-summary-view">
          {
            //@ts-ignore
            data &&
              data?.creditorContactList &&
              data?.creditorContactList?.map((contact: any, index: number) => (
                <>
                  <div className="motif-container ccwp_claim_summary_white_accordian pad-h-0 pad-b-20">
                   {/* main accordian, container*/}
                   <MotifAccordionGroup>
                    <MotifAccordion
                      onClose={() => setContactsAccordianOpen(false)}
                      onOpen={() => setContactsAccordianOpen(true)}
                      style={{
                        flex: "1",
                      }}
                      alignIconRight={true}
                      useChevronIcon={true}
                      open={contactsAccordianOpen}
                    >
                      <MotifAccordionTrigger style={{padding:"5px 0px"}}>
                        <div className="ccwp_claim_summary_white contacts-header motif-row">
                          <div className="motif-body2-default-bold" style={{padding:"0px 20px 0px 10px", borderRight:'1px solid black'  }}>
                            <div className="motif-body2-default-regular page-description mar-b-0">{t("Name")}</div>
                            <div>
                              {contact.firstName + " " + contact.lastName}
                            </div>
                          </div>
                          <div className="motif-body2-default-bold" style={{padding:"0px 10px 0px 20px", }}>
                            <div className="motif-body2-default-regular page-description mar-b-0">{t(
                                      "pages.creditors.creditorForm.formLabelDetails.relationshipToCreditor"
                                    )}</div>
                            <div>
                              {contact.relationshipToCreditor}
                            </div>
                          </div>
                          <div style={{padding:'0px 10px 0px 10px', display:"flex"}}>
                          {contact.contactId ===
                              data?.creditorIdentifier?.primaryContactId ? (
                            <MotifChip
                              dotSide="left"
                              type="chip"
                              variant="monochrome-dark"
                            >
                              {t(
                                "pages.creditors.creditorForm.formLabelDetails.primary"
                              )}
                            </MotifChip>
                          ) :""}

                          </div>
                        </div>
                      </MotifAccordionTrigger>
                      <MotifAccordionContent className="contact-details-container">
                        {/* contact details tile */}
                        <div className="motif-container ccwp_claim_summary_white_accordian mar-t-20 pad-0">
                          <MotifAccordion
                            onClose={() =>function Ua() {}}
                            onOpen={() => function Ua() {}}
                            style={{
                              flex: "1",
                            }}
                            alignIconRight={true}
                            className="mar-b-20"
                            open={true}
                          >
                            {/* <MotifAccordionTrigger>
                              <div className="ccwp_claim_summary_white">
                                <label>{"Details"}</label>
                              </div>
                            </MotifAccordionTrigger> */}
                            {/* Contact details start */}
                            <MotifAccordionContent>
                              <div className="motif-row">
                                {contact?.usedAsAdditionalPayeeType && (
                                  <div className="motif-col-lg-3">
                                    <div className="title">
                                      {t(
                                        "pages.creditors.creditorView.additionalPayeeType"
                                      )}
                                    </div>
                                    <div className="motif-body2-default-bold">
                                      {renderPayeeName(
                                        contact?.additionalPayeeTypeId
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.prefix"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.prefix || "-"}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.firstName"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.firstName}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.lastName"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.lastName}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.businessName"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.businessName}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3"></div>
                              </div>
                              <div className="motif-row pad-t-30">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.email"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold line-break">
                                    {contact.email}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.phoneNumber"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.phone}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.fax"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.fax}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.relationshipToCreditor"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold ">
                                    {contact.relationshipToCreditor}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3"></div>
                              </div>
                              <div className="motif-row pad-t-30">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                  {t("pages.creditors.creditorForm.formLabelDetails.governmentID1")}
                                  </div>
                                  <div  className="motif-body2-default-bold line-break">
                                  <MaskedLabel value={contact.governmentId1}></MaskedLabel>

                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                  {t("pages.creditors.creditorForm.formLabelDetails.governmentIDType1")}

                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {t(getGovernmentType(contact.governmentId1Type))}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                  {t("pages.creditors.creditorForm.formLabelDetails.governmentID2")}

                                  </div>
                                  <div className="motif-body2-default-bold">
                                  <MaskedLabel value={contact.governmentId2}></MaskedLabel>
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                  {t("pages.creditors.creditorForm.formLabelDetails.governmentIDType2")}

                                  </div>
                                  <div className="motif-body2-default-bold ">
                                    {t(getGovernmentType(contact.governmentId2Type))}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3"></div>
                              </div>
                            </MotifAccordionContent>
                            {/*Contact details end */}
                          </MotifAccordion>
                        </div>
                        {/* Address tile */}
                        <div className="motif-container ccwp_claim_summary_white_accordian mar-t-20 pad-0 hide-minus-icon" style={{"position":"relative"}}>
                          <MotifAccordion
                            onClose={() =>function Ua() {}}
                            onOpen={() => function Ua() {}}
                            style={{
                              flex: "1",
                            }}
                           alignIconRight={true}
                           className="mar-b-20"
                            open={true}
                          >
                            <MotifAccordionTrigger>
                              <div className="ccwp_claim_summary_white">
                                <label>
                                  {t(
                                    "pages.creditors.creditorForm.formLabelDetails.address"
                                  )}
                                </label>
                                <div style={{"position":"absolute","right":"25px","top":"8px"}}>
                                <CommonTooltipWrapper tooltipTitle={t("global.globalActions.copyToClipboard")}>
                                  <MotifIconButton
                                    size="small"
                                    onClick={(event: any) => copiedToClipBoard(event,contact)}
                                    type="button"
                                    >
                                    {getCommonCopyImg()}
                                  </MotifIconButton>
                                </CommonTooltipWrapper>
                                </div>
                              </div>
                            </MotifAccordionTrigger>
                            <MotifAccordionContent>
                              <div className="motif-row">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.address1"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.address1}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3"></div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.address2"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.address2}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3"></div>
                              </div>
                              <div className="motif-row pad-t-30">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.city"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.city}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.provinceState"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.provinceStateCode || contact.provinceState}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.postalCode"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.postalCode}
                                  </div>
                                </div>
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.country"
                                    )}
                                  </div>
                                  <div className="motif-body2-default-bold">
                                    {contact.country}
                                  </div>
                                </div>
                              </div>
                            </MotifAccordionContent>
                          </MotifAccordion>
                        </div>
                        {/* Payment tile */}
                        <div className="motif-container ccwp_claim_summary_white_accordian mar-t-20 pad-0 hide-minus-icon">
                          <MotifAccordion
                           onClose={() =>function Ua() {}}
                           onOpen={() => function Ua() {}}
                            style={{
                              flex: "1",
                            }}
                            alignIconRight={true}
                            className="mar-b-20"
                            open={true}
                          >
                            <MotifAccordionTrigger>
                              <div className="ccwp_claim_summary_white">
                                <label>
                                  {t(
                                    "pages.creditors.creditorView.payementDetails"
                                  )}
                                </label>
                              </div>
                            </MotifAccordionTrigger>
                            <MotifAccordionContent>
                              <div className="motif-row payment-fields">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.institutionNumber"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.institutionNumber}
                                    name={"institutionNumber"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                                <div className="motif-col-lg-2">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.transitNumber"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.transitNumber}
                                    name={"transitNumber"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                                <div className="motif-col-lg-2">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.accountNumber"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.accountNumber}
                                    name={"accountNumber"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                                <div className="motif-col-lg-2">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.IBANNumber"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.ibanNumber}
                                    name={"ibanNumber"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                                <div className="motif-col-lg-2">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.routingCode"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.routingCode}
                                    name={"routingCode"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                              </div>
                              <div className="motif-row pad-t-30 payment-fields">
                                <div className="motif-col-lg-3">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.SWIFTCode"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.swiftCode}
                                    name={"swiftCode"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                                <div className="motif-col-lg-2">
                                  <div className="title">
                                    {t(
                                      "pages.creditors.creditorForm.formLabelDetails.ACHCode"
                                    )}
                                  </div>
                                  <MaskedInput
                                    value={contact.achCode}
                                    name={"achCode"}
                                    index={index}
                                    handleViewIcon={handleViewIcon}
                                    showField={showField}
                                  />
                                </div>
                              </div>
                            </MotifAccordionContent>
                          </MotifAccordion>
                        </div>
                      </MotifAccordionContent>
                    </MotifAccordion>
                    </MotifAccordionGroup>
                  </div>
                </>
              ))
          }
        </div>
      </div>
      <CreditorFileuploader />
      <CommentHistory
        entityType={ENTITYTYPE.creditor}
        dataId={creditorId || ""}
      />
    </>
  );
}

export default CreditorSummary;
